import React, { useState } from "react";

const StoryCard = ({ story, onOpen }) => {
    const [isLoaded, setIsLoaded] = useState(false);

    return (
        <div
            onClick={onOpen}
            // Changed aspect ratio from aspect-[3/4] to aspect-[4/3] for a shorter, wider card.
            // This also helps show more of the image without vertical cropping.
            className="reveal group relative rounded-3xl overflow-hidden bg-gray-100 dark:bg-gray-800 aspect-[4/3] cursor-zoom-in shadow-sm hover:shadow-md transition-all"
        >
            {/* Skeleton Loader */}
            {!isLoaded && (
                <div className="absolute inset-0 bg-gray-200 dark:bg-gray-700 animate-pulse z-10" />
            )}

            {/* Background Image */}
            <img
                src={story.image}
                alt={story.title}
                // object-cover ensures the card is filled. The new aspect ratio reduces height.
                className={`w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105 ${
                    isLoaded ? "opacity-100" : "opacity-0"
                }`}
                onLoad={() => setIsLoaded(true)}
            />

            {/* Gradient Overlay - Made darker for better text contrast */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent opacity-80 group-hover:opacity-95 transition-opacity duration-500 z-20"></div>

            {/* Card Content */}
            <div className="absolute bottom-0 left-0 right-0 p-6 z-30">
                <div className="flex flex-wrap gap-2 mb-3">
                    {/* Increased contrast for tags */}
                    <span className="px-3 py-1 rounded-full bg-primary text-white text-[10px] font-bold uppercase tracking-wider shadow-sm">
                        {story.tag}
                    </span>
                    <span className="px-3 py-1 rounded-full bg-white/20 backdrop-blur-md text-white text-[10px] font-medium uppercase tracking-wider border border-white/10">
                        {story.moment}
                    </span>
                </div>

                {/* Title is now more prominent */}
                <h3 className="text-white text-2xl font-bold font-display leading-tight transition-colors drop-shadow-sm">
                    {story.title}
                </h3>

                {/* Location with better contrast */}
                <p className="text-gray-200 text-xs mt-2 flex items-center gap-1.5 drop-shadow-sm">
                    <span className="material-symbols-outlined text-sm">location_on</span>
                    {story.location}
                </p>

                {/* Hidden Content (Reveals on Hover) */}
                <div className="max-h-0 overflow-hidden group-hover:max-h-48 transition-all duration-500 ease-in-out">
                    <p className="text-gray-100 text-sm mt-4 line-clamp-3 italic leading-relaxed drop-shadow-sm">
                        "{story.description}"
                    </p>
                    <div className="mt-4 pt-4 border-t border-white/20">
                        <p className="text-primary-light text-[11px] font-black uppercase tracking-[0.2em] drop-shadow-sm">
                            {story.emotion}
                        </p>
                    </div>
                </div>
            </div>

            {/* Subtle Zoom Icon on Top Right */}
            <div className="absolute top-4 cursor-pointer right-4 size-10 rounded-full bg-black/30 backdrop-blur-md border border-white/10 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity z-30">
                <span className="material-symbols-outlined text-white text-xl">fullscreen</span>
            </div>
        </div>
    );
};

export default StoryCard;